















import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class RadioButtonBox extends Vue {
  @Prop() value!: string;
  @Prop() model!: string;
  @Prop() name!: string;

  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
  }
}
